import { type RequestPayload, router } from "@inertiajs/core";
import { Link, usePage } from "@inertiajs/react";
import { Anchor, Button, Checkbox, Container, Flex, Input, Paper, PasswordInput, Stack, TextInput, Title } from "@mantine/core";
import { useForm } from "@mantine/form";
import { new_user_password_path, new_user_session_path } from "../../routes";

type FormErrors = {
  email?: string;
};

export default function Login() {
  const { errors } = usePage<{ errors: FormErrors }>().props;
  const hasErrors = !!errors.email;
  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      user: {
        email: "",
        password: "",
        remember_me: 0,
      },
    },
  });

  const login = (values: RequestPayload) => router.post(new_user_session_path(), values);

  return (
    <Container fluid mt="4rem">
      <Flex justify="center" align="center">
        <form onSubmit={form.onSubmit((values) => login(values))}>
          <Paper shadow="sm" p="lg" withBorder w="40rem" maw="40rem">
            <Stack>
              <Title order={2}>Login</Title>
              <TextInput type="email" label="E-Mail" key={form.key("user.email")} {...form.getInputProps("user.email")} error={hasErrors} />
              <PasswordInput label="Passwort" key={form.key("user.password")} {...form.getInputProps("user.password")} error={hasErrors} />
              {errors && <Input.Error>{errors.email}</Input.Error>}
              <Checkbox
                label="Angemeldet bleiben"
                key={form.key("remember_me")}
                {...form.getInputProps("user.remember_me", {
                  type: "checkbox",
                })}
              />
              <Anchor component={Link} href={new_user_password_path()}>
                Password vergessen
              </Anchor>
              <Button type="submit">Einloggen</Button>
            </Stack>
          </Paper>
        </form>
      </Flex>
    </Container>
  );
}
